import { CardConnectCardOnFile } from './card-connect-card-on-file.interface';
import { StripeCardOnFile } from './stripe-card-on-file.interface';

export class CardOnFile {
    cardConnect?: CardConnectCardOnFile;
    stripe?: StripeCardOnFile;

    id: string;
    cardType: string;
    displayNumber: string;
    expirationStatus: string;
    isExpired: boolean;

    constructor(
        cardConnect?: CardConnectCardOnFile,
        stripe?: StripeCardOnFile
    ) {
        this.cardConnect = cardConnect;
        this.stripe = stripe;

        if (cardConnect) {
            this.id = cardConnect.accountID.toString();
            this.cardType = cardConnect.cardType;
            this.displayNumber = cardConnect.token;
            this.expirationStatus = cardConnect.expirationStatus;
            this.isExpired = cardConnect.isExpired;
        } else if (stripe) {
            this.id = stripe.paymentMethodID;
            this.cardType = stripe.brand;
            this.displayNumber = stripe.last4;
            this.expirationStatus = stripe.expirationStatus;
            this.isExpired = stripe.isExpired;
        }
    }

    isCardConnect(): boolean {
        return !!this.cardConnect;
    }

    isStripe(): boolean {
        return !!this.stripe;
    }
}
